import Link from 'next/link';
import React from 'react';

import type { SvrWTeamLogo } from '@poseidon/types/svr/svrTeam.type';
import type { SvrUserTeamBase } from '@poseidon/types/svr/svrUserTeam.type';
import { TeamAvatar, TeamUserAvatar } from '@poseidon/components/Avatar';
import { cn } from '@poseidon/components/cn';
import { Security } from '@poseidon/components/StrokeIcons';
import { Tooltip } from '@poseidon/components/Tooltip';

import { ButtonLink } from '@/components/Button';
import { dataOnboardingIds } from '~/components/Onboarding/onboarding.model';

interface UserLogoutRowProps {
  authData: SvrUserTeamBase & SvrWTeamLogo;
  minimized?: boolean;
}
export const UserLogoutRow = ({ authData, minimized }: UserLogoutRowProps) => {
  const name = authData.userTeamName ?? authData.userEmail;
  const teamName = authData.teamName;

  return (
    <div className="whitespace-prete flex flex-row items-center gap-1 overflow-hidden pt-6">
      <Tooltip label={minimized ? `${name} (${teamName})` : undefined}>
        <Link
          className={cn(
            'relative flex flex-shrink flex-grow basis-0 cursor-pointer flex-row gap-3 rounded-md p-2 transition-colors hover:bg-gray-100 dark:hover:bg-slate-900',
          )}
          href={`/teams/active/user`}
          data-onboarding={dataOnboardingIds.settingsTrigger}>
          <TeamUserAvatar nextjs className="size-10" shape="circle" userTeam={authData} />

          <TeamAvatar
            nextjs
            className="absolute bottom-1 left-1 size-5"
            logo={authData.teamLogo}
            name={authData.teamName}
            shape="circle"
          />
          <div className="flex w-0 flex-shrink flex-grow basis-0 flex-col overflow-hidden text-ellipsis">
            <div className="max-h-5 overflow-hidden text-ellipsis text-sm font-semibold text-gray-700 dark:text-white">
              {name}
            </div>
            <div className="max-h-5 overflow-hidden text-ellipsis text-sm font-normal text-gray-500 dark:text-gray-400">
              {authData.teamName}
            </div>
          </div>
        </Link>
      </Tooltip>
      {authData.isSuperAdmin && (
        <ButtonLink tooltip="Super Admin" icon={<Security.Fingerprint01 />} href="/superadmin" />
      )}
    </div>
  );
};
